export interface MediaDB {
    img: string;
    file_name: string;
    url: string;
}

export const MEDIADB: MediaDB[] = [
    {
        img: 'assets/images/dashboard/product/1.jpg',
        file_name: "Honor_Mobile.jpg",
        url: "http://www.assets/images/product/product/13.jpg",
    },
    {
        img: 'assets/images/dashboard/product/2.jpg',
        file_name: "Samsung_LED_TV.jpeg",
        url: "http://www.assets/images/electronics/product/12.jpg",
    },
    {
        img: 'assets/images/dashboard/product/3.jpg',
        file_name: "Motorola_Bluetooth.jpg",
        url: "http://www.assets/images/electronics/product/25.jpg",
    },
    {
        img: 'assets/images/dashboard/product/4.jpg',
        file_name: "headphones.jpg",
        url: "http://www.assets/images/electronics/product/16.jpg",
    },
    {
        img: 'assets/images/dashboard/product/5.jpg',
        file_name: "Apple_6s.jpeg",
        url: "http://www.assets/images/electronics/product/21.jpg",
    },
    {
        img: 'assets/images/dashboard/product/6.jpg',
        file_name: "Printer.jpeg",
        url: "http://www.assets/images/electronics/product/3.jpg",
    },
    {
        img: 'assets/images/dashboard/product/7.jpg',
        file_name: "Canon_Camera.jpg",
        url: "http://www.assets/images/electronics/product/14.jpg",
    },
    {
        img: 'assets/images/dashboard/product/8.jpg',
        file_name: "High_Quality_Headphones.jpg",
        url: "http://www.assets/images/electronics/product/20.jpg",
    },
    {
        img: 'assets/images/dashboard/product/9.jpg',
        file_name: "Home_Theater_Speakers.jpg",
        url: "http://www.assets/images/electronics/product/19.jpg",
    },
    {
        img: 'assets/images/dashboard/product/10.jpg',
        file_name: "Diamond_Ring.jpg",
        url: "http://www.assets/images/jewellery/pro/18.jpg",
    },
    {
        img: 'assets/images/dashboard/product/11.jpg',
        file_name: "Diamond_Nacklace.jpeg",
        url: "http://www.assets/images/jewellery/pro/12.jpg",
    },
    {
        img: 'assets/images/dashboard/product/12.jpg',
        file_name: "Diamond_Earrings.jpeg",
        url: "http://www.assets/images/jewellery/pro/26.jpg",
    },
    {
        img: 'assets/images/dashboard/product/13.jpg',
        file_name: "Night_lamp.jpg",
        url: "http://www.assets/images/furniture/8.jpg",
    },
    {
        img: 'assets/images/dashboard/product/14.jpg',
        file_name: "men's_shoes.jpg",
        url: "http://www.assets/images/cat3.png",
    },
    {
        img: 'assets/images/dashboard/product/15.jpg',
        file_name: "Ledi's_red_top.jpeg",
        url: "http://www.assets/images/fashion/product/12.jpg",
    },
    {
        img: 'assets/images/dashboard/product/16.jpg',
        file_name: "latest_ledis_shoes.jpg",
        url: "http://www.assets/images/fashion/pro/shoes.jpg",
    },
    {
        img: 'assets/images/dashboard/product/17.jpg',
        file_name: "Apple_6s.jpeg",
        url: "http://www.assets/images/electronics/product/21.jpg",
    },
    {
        img: 'assets/images/dashboard/product/18.jpg',
        file_name: "Printer.jpg",
        url: "http://www.assets/images/electronics/product/3.jpg",
    },
    {
        img: 'assets/images/dashboard/product/19.jpg',
        file_name: "High_Quality_Headphones.jpg",
        url: "http://www.assets/images/electronics/product/20.jpg",
    },
    {
        img: 'assets/images/dashboard/product/20.jpg',
        file_name: "Motorola_Bluetooth.jpg",
        url: "http://www.assets/images/electronics/product/25.jpg",
    },
]
